import { makeThemedComponent } from '@minerva-analytics/pantheon';
import { css } from 'styled-components';

import { BLUE, WHITE, H4 } from 'root/theme';

const CardHeader = makeThemedComponent({
  themeKey: `CardHeader`,
  component: `div`,
  defaultStyles: css`
    ${H4}
    background-color: ${BLUE};
    color: ${WHITE};
    padding: 1rem 0;
    text-align: center;
  `,
});

export default CardHeader;
